import { render } from "./TreatmentDetailSelector.vue?vue&type=template&id=6d56e751&scoped=true&ts=true"
import script from "./TreatmentDetailSelector.vue?vue&type=script&lang=ts"
export * from "./TreatmentDetailSelector.vue?vue&type=script&lang=ts"

import "./TreatmentDetailSelector.vue?vue&type=style&index=0&id=6d56e751&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d56e751"]])

export default __exports__